import { BedAgeSpanSettings } from "../api/contracts/site-config";
import { BedCapacityType } from "../api/contracts/reservation";

export const getBedTypeForAge = (
  age: number,
  bedAgeSpanSettings: BedAgeSpanSettings,
): BedCapacityType => {
  if (age <= bedAgeSpanSettings.maxAgeCot) {
    return "cot";
  }
  if (age <= bedAgeSpanSettings.maxAgeHalfSize) {
    return "half";
  }
  return "full";
};

export const getAllowedBedTypesForAge = (
  age: number,
  bedAgeSpanSettings: BedAgeSpanSettings,
): BedCapacityType[] => {
  const types: BedCapacityType[] = [];

  // Always allow the recommended type
  const recommended = getBedTypeForAge(age, bedAgeSpanSettings);
  types.push(recommended);

  // Allow "upgrades" - older children can use full beds
  if (age > bedAgeSpanSettings.maxAgeCot && !types.includes("half")) {
    types.push("half");
  }
  if (age > bedAgeSpanSettings.maxAgeHalfSize && !types.includes("full")) {
    types.push("full");
  }

  return types;
};

export const getAgeRangesForBedTypes = (
  bedAgeSpanSettings: BedAgeSpanSettings,
) => ({
  cot: { min: 0, max: bedAgeSpanSettings.maxAgeCot },
  half: {
    min: bedAgeSpanSettings.maxAgeCot + 1,
    max: bedAgeSpanSettings.maxAgeHalfSize,
  },
  full: { min: bedAgeSpanSettings.maxAgeHalfSize + 1, max: 18 },
});
